import { confirmCancelChanges } from '../../popup';

export const SaveCancelButtons = ({ onEditMode, passive, hasChanges, handleSaveAndExit, dispatch, setOnEditMode }) => {
    const isEditionActive = onEditMode;
    const isNotPassive = !passive;
    const shouldShowButtons = isEditionActive && isNotPassive;

    if (!shouldShowButtons) return null;

    const canSave = hasChanges;

    return (
        <span className="save-cancel-btns">
            <button
                id="saveBtn"
                className="save-cancel-btn"
                onClick={handleSaveAndExit}
                disabled={!canSave}
            > ✔</button>
            <button id="cancelBtn" className="save-cancel-btn" onClick={() => confirmCancelChanges(dispatch, setOnEditMode)}> ✖</button>
        </span>
    );
};
